<template>
    <div :id="placeholderId"></div>
</template>

<script>
    export default {
        props: {
            message: String
        },

        data() {
            return {
                sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN,
                placeholderId: 'grecaptcha',
                captchaReady: false, 
                checkingInterval: null,
            }
        },

        mounted() {
            this.checkingInterval = setInterval(() => {
                if (window.grecaptcha) {
                    this.captchaReady = true;
                }
            }, 500)
        },

        watch: {
            captchaReady: function() {
                if (this.captchaReady) {
                    clearInterval(this.checkingInterval);
                    this.render();
                }
            },

            message: function() {
                window.grecaptcha.reset();
            }
        },

        methods: {
            render() {
                window.grecaptcha.render(this.placeholderId, {
                    sitekey: this.sitekey,
                    callback: (response) => {
                        this.$emit('reCaptchaResponse', response);
                    },
                    ['expired-callback']: () => {
                        this.$emit('reCaptchaResponse', null);
                    }
                });
            }
        }
    }
</script>
